(function() {
  var VIEWPORT_THRESHOLD = 0.5;
  var VIDEO_SELECTOR = '.ctr-advertorial-body__content-video';
  var SECTION_SELECTOR = '.ctr-advertorial-body';

  var state = new WeakMap();
  var observer = null;

  function playVideo(video) {
    var promise = video.play();
    if (promise && typeof promise.catch === 'function') {
      promise.catch(function() {});
    }
  }

  function ensureObserver() {
    if (observer) return observer;

    observer = new IntersectionObserver(
      function(entries) {
        entries.forEach(function(entry) {
          var video = entry.target;
          var s = state.get(video);
          if (!s) return;

          if (entry.isIntersecting) {
            if (!s.manuallyPaused) {
              playVideo(video);
            }
          } else {
            video.pause();
            s.manuallyPaused = false;
          }
        });
      },
      { threshold: VIEWPORT_THRESHOLD }
    );

    return observer;
  }

  function onVideoClick(video) {
    return function() {
      var s = state.get(video);
      if (!s) return;

      if (video.paused) {
        playVideo(video);
        s.manuallyPaused = false;
      } else {
        video.pause();
        s.manuallyPaused = true;
      }
    };
  }

  function bindVideo(video) {
    if (state.has(video)) return;

    var clickHandler = onVideoClick(video);

    var volumeHandler = function() { video.muted = true; };
    video.muted = true;
    video.controls = false;
    video.removeAttribute('controls');
    video.addEventListener('click', clickHandler);
    video.addEventListener('volumechange', volumeHandler);

    state.set(video, {
      manuallyPaused: false,
      clickHandler: clickHandler,
      volumeHandler: volumeHandler
    });

    ensureObserver().observe(video);
  }

  function unbindVideo(video) {
    var s = state.get(video);
    if (!s) return;

    video.removeEventListener('click', s.clickHandler);
    video.removeEventListener('volumechange', s.volumeHandler);

    if (observer) {
      observer.unobserve(video);
    }

    state.delete(video);
  }

  function initSection(section) {
    if (!section) return;
    section.querySelectorAll(VIDEO_SELECTOR).forEach(bindVideo);
  }

  function destroySection(section) {
    if (!section) return;
    section.querySelectorAll(VIDEO_SELECTOR).forEach(unbindVideo);
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e) {
    var section = e.target.querySelector(SECTION_SELECTOR) || e.target.closest(SECTION_SELECTOR);
    initSection(section);
  });

  document.addEventListener('shopify:section:unload', function(e) {
    var section = e.target.querySelector(SECTION_SELECTOR) || e.target.closest(SECTION_SELECTOR);
    destroySection(section);
  });
})();
